/* eslint-disable */
import React, { Component } from "react";
import PropTypes from "prop-types";
import ChipInput from "material-ui-chip-input";
import { translate, FieldTitle } from "admin-on-rest";
import Snackbar from 'material-ui/Snackbar';
import { red500 } from "material-ui/styles/colors";
import { dataColors } from '../styles';

const dataSourceConfig = { text: "text", value: "value" };

export class EditSelectColorChipInput extends Component {
  state = {
    values: [],
    defaultValue:[],
    autoHideDuration: 2000,
    message: 'This Item Can\'t delete',
    open: false,
  };

  componentWillMount = () => {
    this.setState({
      values: this.getChoicesForValues(
        this.props.input.value || [],
        this.props.choices
      ),
      defaultValue: this.getChoicesForValues(
        this.props.input.value || [],
        this.props.choices
      )
    });
    
  };

  
  handleBlur = () => {
    const extracted = this.extractIds(this.state.values);
    this.props.onBlur(extracted);
    this.props.input.onBlur(extracted);
    this.setState({ open: false });
  };

  handleFocus = () => {
    const extracted = this.extractIds(this.state.values);
    this.props.onFocus(extracted);
    this.props.input.onFocus(extracted);
    this.setState({ open: false });
  };

  handleAdd = newValue => {
    // this for check the value from choice or not
    //check to case sensitif
    const values1 = this.state.values.filter(v => {
			let a = v.value;
			const b = newValue.value;
			if(a) {
				a = a.toLowerCase();
			}
			return(b.toLowerCase() === a);
		});
		if(values1.length === 0){
			const values = [...this.state.values, newValue];
			this.setState({ values });
			this.handleChange(values);
		}
    //const values1 = dataColors.filter(v => v.id === newValue.value);
    // const values = [...this.state.values, newValue];
    // this.setState({ values, open: false });
    // this.handleChange(values);
    // if (values1.length !== 0) {
      
    // }
  };

  handleDelete = newValue => {
    const isHaveValue = this.state.defaultValue.filter(v => v.value === newValue);
    if(isHaveValue.length === 0){
      const values = this.state.values.filter(v => v.value !== newValue);
      this.setState({ values, open: false });
      this.handleChange(values);
    }else {
      const message = 'Item '+isHaveValue[0].text+' Can\'t delete';
      this.setState({ open: true, message });
    }
    
  };

  handleChange = eventOrValue => {
    const extracted = this.extractIds(eventOrValue);
    this.props.onChange(extracted);
    this.props.input.onChange(extracted);
  };

  extractIds = eventOrValue => {
    const value =
      eventOrValue.target && eventOrValue.target.value
        ? eventOrValue.target.value
        : eventOrValue;
        
    if (Array.isArray(value)) {
      return value.map(o => o.value);
    }
    return [value];
  };

  getChoicesForValues = (values, choices = []) => {
    const { optionValue, optionText } = this.props;
    if (!values || !Array.isArray(values)) {
        throw Error('Value of SelectArrayInput should be an array');
    }
    return values
        .map(
            value =>
                choices.find(c => c[optionValue] === value) || {
                    [optionValue]: value,
                    [optionText]: value,
                }
        )
        .map(this.formatChoice);
};

  formatChoices = choices => choices.map(this.formatChoice);

  formatChoice = choice => {
    const { optionText, optionValue, translateChoice, translate } = this.props;
    const choiceText =
      typeof optionText === "function"
        ? optionText(choice)
        : choice[optionText];
    return {
      value: choice[optionValue],
      text: translateChoice
        ? translate(choiceText, { _: choiceText })
        : choiceText
    };
  };

  render() {
    const {
      elStyle,
      input,
      isRequired,
      choices,
      label,
      meta,
      options,
      resource,
      source,
      setFilter,
  } = this.props;
  if (typeof meta === 'undefined') {
      throw new Error(
          "The SelectArrayInput component wasn't called within a redux-form <Field>. Did you decorate it and forget to add the addField prop to your component? See https://marmelab.com/admin-on-rest/Inputs.html#writing-your-own-input-component for details."
      );
  }
  const { touched, error } = meta;
    
    return (
      <div>
      <ChipInput
      {...input}
      value={this.state.values}
      onBlur={this.handleBlur}
      onFocus={this.handleFocus}
      onClick={this.handleFocus}
      onRequestAdd={this.handleAdd}
      onRequestDelete={this.handleDelete}
      onUpdateInput={setFilter}
      floatingLabelText={
          <FieldTitle
              label={label}
              source={source}
              resource={resource}
              isRequired={isRequired}
          />
      }
      errorText={touched && error}
      style={elStyle}
      dataSource={this.formatChoices(choices)}
      dataSourceConfig={dataSourceConfig}
      openOnFocus
      {...options}
      />
      <Snackbar
          open={this.state.open}
          message={this.state.message}
          bodyStyle={{ backgroundColor: red500 }}
          autoHideDuration={this.state.autoHideDuration}
        />
     </div> 
    );
  }
}

EditSelectColorChipInput.propTypes = {
  addField: PropTypes.bool.isRequired,
  elStyle: PropTypes.object,
  choices: PropTypes.arrayOf(PropTypes.object),
  input: PropTypes.object,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  meta: PropTypes.object,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  setFilter: PropTypes.func,
  options: PropTypes.object,
  optionText: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  optionValue: PropTypes.string.isRequired,
  resource: PropTypes.string,
  source: PropTypes.string,
  translateChoice: PropTypes.bool.isRequired,
};

EditSelectColorChipInput.defaultProps = {
  addField: true,
  choices: dataColors,
  onBlur: () => true,
  onChange: () => true,
  onFocus: () => true,
  options: { fullWidth: true },
  optionText: "name",
  optionValue: "id",
  translateChoice: false
};

export default translate(EditSelectColorChipInput);



// WEBPACK FOOTER //
// ./src/products/edit/EditSelectColorChipInput.js